// 圣遗物类型对应品质限制
export const ArtifactStarLimitation = {
  51: [3, 4],
  52: [3, 4],
  53: [3, 4],
  54: [3, 4],
  55: [2, 3, 4],  // 战狂
  56: [3, 4],     // 武人
  57: [3, 4],     // 教官
  58: [3, 4],     // 赌徒
  59: [3, 4],     // 流放者
  60: [1, 2, 3],  // 冒险家
  61: [1, 2, 3],  // 幸运儿
  62: [2, 3, 4],  // 学士
  63: [1, 2, 3],  // 游医
  71: [4, 5],
  72: [4, 5],
  73: [4, 5],
  74: [4, 5],
  75: [4, 5],
  76: [4, 5],
  77: [4, 5],
  78: [4, 5],
  79: [4, 5],
  80: [4, 5],
  81: [4, 5],
  82: [4, 5],
  83: [3, 4],
  84: [3, 4],
  85: [3, 4],
  86: [3, 4],
  87: [3, 4],
  88: [4, 5],
  89: [4, 5],
  90: [4, 5],
  91: [4, 5],
  92: [4, 5],
  93: [4, 5],
  94: [4, 5],
  95: [4, 5],
  96: [4, 5],
  97: [4, 5],
  98: [4, 5],
  99: [4, 5],
  20: [4, 5],
  21: [4, 5],
};

// 圣遗物类型对应主词条限制
export const ArtifactMainAttrsLimitation = {
  flower: ['10001'],
  feather: ['10003'],
  sand: ['10002', '10004', '10006', '10007', '10008'],
  cup: ['15008', '15009', '15010', '15011', '15012', '15013', '15014', '15015', '15002', '15004', '15006', '15007'],
  head: ['13002', '13004', '13006', '13007', '13008', '13009', '13010'],
};

export const DuplicatedArtifact = [99, 78, 86];

// 5星：初始3-4词条，强化最多5次，最多9个词条（面板4词条)，同一个词条出现的最高数量 6 次 （9 - 4 + 1）
// 4星：初始2-3词条，强化最多4次，最多7个词条（面板4词条)，同一个词条出现的最高数量 4 次 （7 - 4 + 1）
// 3星：初始1-2词条，强化最多3次，最多5个词条（面板4词条)，同一个词条出现的最高数量 2 次 （5 - 4 + 1）
// 2星：初始0-1词条，强化最多1次，最多2个词条，同一个词条出现的最高数量 1 次
// 1星：初始0词条，强化最多1次，最多1个词条，同一个词条出现的最高数量 1 次
// 圣遗物品质对应副词条种类数量限制
export const ArtifactSubAttrCateLimitation = {
  5: 4,
  4: 4,
  3: 4,
  2: 2,
  1: 1,
};
// 圣遗物品质对应满词条所需等级
export const ArtifactSubAttrFullCateNeedLevel = {
  5: 0, // 可能不需要强化就满词条
  4: 4, // 至少强化1次
  3: 8, // 至少强化2次
  2: 4, // 只能强化1次
  1: 4, // 只能强化1次
};
// 圣遗物品质对应副词条总数限制
export const ArtifactSubAttrMaxLimitation = {
  5: 9,
  4: 7,
  3: 5,
  2: 2,
  1: 1,
};
// 圣遗物强化最大次数限制
export const ArtifactUpdateTimeLimitation = {
  5: 5,
  4: 4,
  3: 3,
  2: 1,
  1: 1,
};
// 圣遗物最大等级限制
export const ArtifactLevelLimitation = {
  5: 20,
  4: 16,
  3: 12,
  2: 4,
  1: 4,
};
// 圣遗物品质对应单种副词条出现最大次数限制
export const ArtifactSubAttrCateMaxLimitation = {
  5: 6,
  4: 4,
  3: 2,
  2: 1,
  1: 1,
};

export const ArtifactSubAttrsExcludeByMaster = {
  生命值: '102',
  生命值百分比: '103',
  攻击力: '105',
  攻击力百分比: '106',
  防御力: '108',
  防御力百分比: '109',
  元素充能效率: '123',
  元素精通: '124',
  暴击率: '120',
  暴击伤害: '122',
};
